"use client";

import { GridBorderedSection, GridDivider } from "@/components/homepage/GridLayout";
import { HomepageFooter } from "@/components/homepage/HomepageFooter";
import { PageLayout } from "@/components/ui/page-layout";
import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";
import type { ReactNode } from "react";

export function AppDetailPageShell({ children }: { children: ReactNode }) {
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <PageLayout>{children}</PageLayout>;
  }

  return (
    <div className="bg-ds-surface-primary relative">
      <div className="relative z-[2] px-4 2xl:px-0">
        <GridBorderedSection className="h-[72px]" />
        <GridDivider variant={2} />
        <GridBorderedSection>
          <div className="mx-auto w-full max-w-[1280px] px-0 pb-10 pt-2.5 md:px-8 md:pb-14">{children}</div>
        </GridBorderedSection>
        <GridDivider variant={2} />
        <GridBorderedSection>
          <HomepageFooter />
          <GridDivider variant={2} />
          <GridBorderedSection className="h-[60px]" />
        </GridBorderedSection>
      </div>
    </div>
  );
}
